import dynamic from 'next/dynamic'

export const ComparisonTable = dynamic(() => import('./comparison-table'))
